export default __webpack_public_path__ + "static/media/project_lg_autopartes_0.54c4ed10.png";